// Apple Search Ads ID -> friendly name.
//
// Apple's attribution API only returns numeric IDs, never the campaign,
// ad group or keyword text, so the names have to be mapped here.
//
// To find an ID in the Apple Ads dashboard (ads.apple.com):
//  - Click into a campaign / ad group / keyword and read the ID from the URL, or
//  - Download a report (Reports → download CSV), which includes the ID columns
//    alongside the names.
//
// Anything not listed falls back to "#<id>".

export const CAMPAIGN_NAMES: Record<string, string> = {
  '2144182769': 'Identify',
  '2144428586': 'Disease',
  '2150465586': 'Doctor',
  '2144500680': 'doctor-uk',
  '2144542333': 'max conversion us',
};

export const AD_GROUP_NAMES: Record<string, string> = {
  '144500680': 'doctor-uk',
  // '2150218579': 'Disease — broad',
  // '2149549379': 'Identify — exact',
};

// "plant doctor" legitimately appears three times below: Apple issues a distinct
// keyword id per ad group, so the same keyword text bid on in three campaigns has
// three ids. The Campaign column in the report keeps the rows distinguishable.
export const KEYWORD_NAMES: Record<string, string> = {
  // Doctor UK campaign
  '2303028322': 'plant doctor',
  // Identify campaign
  '2286411079': 'indoor plants',
  '2286411074': 'plant disease',
  '2286411068': 'plant scanner',
  '2286411081': 'plant app',
  '2286411070': 'plant doctor',
  '2286411065': 'plant id',
  // Disease campaign
  '2299205920': 'sick plant',
  '2299205917': 'plant diagnosis',
  '2299205918': 'plant doctor',
  '2304743383': 'plant disease (broad)',
};

export function campaignName(id: string): string {
  return CAMPAIGN_NAMES[id] || `Campaign #${id}`;
}

export function adGroupName(id: string): string {
  if (!id) return '';
  return AD_GROUP_NAMES[id] || `#${id}`;
}

export function keywordName(id: string): string {
  if (!id) return '';
  return KEYWORD_NAMES[id] || `#${id}`;
}
